interface Props {
  className?: string;
}

export function LogoBeta(props: Props) {
  return (
    <svg
      width="165"
      height="20"
      className={props.className}
      viewBox="0 0 165 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6667 14.5558H24.3143C24.3444 16.0305 25.5178 16.9936 27.2929 16.9936C29.1281 16.9936 30.3918 16.0606 30.3918 14.7364C30.3918 13.7131 29.9405 13.1714 28.6768 12.75L26.2398 11.9374C24.1939 11.2452 23.0807 10.0113 23.0807 8.1152C23.0807 5.43663 25.2771 3.66095 28.6167 3.66095C31.7457 3.66095 33.7314 5.46673 33.7314 8.23559H31.0838C31.0537 6.61039 30.1511 5.79779 28.4362 5.79779C26.7513 5.79779 25.6983 6.58029 25.6983 7.90453C25.6983 8.86761 26.2699 9.52973 27.5336 9.98117L29.9405 10.7938C32.0766 11.5161 33.0394 12.6597 33.0394 14.4956C33.0394 17.2946 30.7227 19.1304 27.1424 19.1304C23.8931 19.1304 21.6667 17.2946 21.6667 14.5558Z"
        fill="#1B2E3F"
      />
      <path
        d="M47.6542 18.7693H34.528V16.482L42.4709 6.42981H34.528V4.0522H45.991V6.36962L37.988 16.3917H47.6542V18.7693Z"
        fill="#1B2E3F"
      />
      <path
        d="M55.1383 16.3014L55.4993 18.6489C54.7472 18.9499 53.9047 19.1003 53.0623 19.1003C50.4749 19.1003 49.0006 17.6256 49.0006 14.6461V6.42981H47.0165V4.0522H49.0006V0H51.8288V4.0522H56.1988V6.42981H51.8288V14.2548C51.8288 15.9402 52.611 16.5723 53.7242 16.5723C54.1454 16.5723 54.6569 16.482 55.1383 16.3014Z"
        fill="#1B2E3F"
      />
      <path
        d="M60.3106 19.1304C57.6931 19.1304 55.948 17.5654 55.948 15.1878C55.948 12.2083 58.1744 10.3423 62.0556 10.0113L66.6589 9.65011L66.7191 9.25886C67.1102 7.06183 65.997 5.85798 63.6803 5.85798C61.4539 5.85798 60.1602 6.82106 59.8593 8.71713H57.3621C57.8736 5.49683 60.2504 3.66095 63.921 3.66095C67.8323 3.66095 69.9383 5.91817 69.3667 9.49963L67.8924 18.7693H65.5457L65.666 16.3616C64.6732 18.0771 62.5972 19.1304 60.3106 19.1304ZM61.2734 16.9936C63.921 16.9936 65.8465 15.2179 66.2678 12.3889L66.3881 11.6064L62.6273 11.9073C59.9796 12.118 58.6859 13.2015 58.6859 14.9471C58.6859 16.2111 59.6487 16.9936 61.2734 16.9936Z"
        fill="#1B2E3F"
      />
      <path
        d="M74.1735 18.7693H71.3453V4.07384H74.1944V5.83729C74.9466 4.45286 76.4601 3.63086 78.536 3.63086C80.8226 3.63086 82.4473 4.77451 83.1995 6.61039C83.8915 4.77451 85.6666 3.63086 87.9532 3.63086C91.3229 3.63086 93.3688 5.7376 93.3688 9.13847V18.7693H90.6008V9.83069C90.6008 7.51328 89.3071 6.18904 87.3213 6.18904C85.1852 6.18904 83.7711 7.69385 83.7711 10.0414V18.7693H80.9731V9.80059C80.9731 7.48318 79.7094 6.21914 77.7237 6.21914C75.5876 6.21914 74.1735 7.69385 74.1735 10.0414V18.7693Z"
        fill="#1B2E3F"
      />
      <path
        d="M99.1846 19.1304C96.5671 19.1304 94.8221 17.5654 94.8221 15.1878C94.8221 12.2083 97.0485 10.3423 100.93 10.0113L105.533 9.65011L105.593 9.25886C105.984 7.06183 104.871 5.85798 102.554 5.85798C100.328 5.85798 99.0342 6.82106 98.7333 8.71713H96.2362C96.7476 5.49683 99.1245 3.66095 102.795 3.66095C106.706 3.66095 108.812 5.91817 108.241 9.49963L106.766 18.7693H104.42L104.54 16.3616C103.547 18.0771 101.471 19.1304 99.1846 19.1304ZM100.147 16.9936C102.795 16.9936 104.721 15.2179 105.142 12.3889L105.262 11.6064L101.501 11.9073C98.8537 12.118 97.56 13.2015 97.56 14.9471C97.56 16.2111 98.5227 16.9936 100.147 16.9936Z"
        fill="#1B2E3F"
      />
      <path
        d="M16.9576 19.9603L7.78278 20L10.7585 1.77883L19.9333 1.73913L16.9576 19.9603Z"
        fill="#EB37FF"
      />
      <path
        d="M5.87671 16.7785L0 16.8043L1.90606 4.96059L7.78278 4.93478L5.87671 16.7785Z"
        fill="#EB37FF"
      />
      <path
        d="M113.042 1.77883L122.217 1.73913L119.241 19.9603L110.067 20L113.042 1.77883Z"
        fill="#FF5E1A"
      />
      <path
        d="M124.123 4.96059L130 4.93478L128.094 16.7785L122.217 16.8043L124.123 4.96059Z"
        fill="#FF5E1A"
      />
      <path
        d="M134 17L135.9 5H140.205C142.138 5 143.399 6.1229 143.399 7.81564C143.399 9.32402 142.575 10.4972 141.079 11.0168C142.172 11.4022 142.744 12.257 142.744 13.4972C142.744 15.6425 141.113 17 138.54 17H134ZM140.036 6.05587H136.875L136.169 10.4804H139.482C141.129 10.4804 142.239 9.4581 142.239 7.9162C142.239 6.75978 141.382 6.05587 140.036 6.05587ZM139.381 11.5028H136.018L135.312 15.9609H138.691C140.474 15.9609 141.583 15.0056 141.583 13.4972C141.583 12.2235 140.776 11.5028 139.381 11.5028Z"
        fill="#FF5E1A"
      />
      <path
        d="M150.144 17H143.082L144.982 5H152.027L151.859 6.07263H145.974L145.268 10.4469H150.615L150.447 11.5028H145.1L144.393 15.9274H150.312L150.144 17Z"
        fill="#FF5E1A"
      />
      <path
        d="M149.495 6.07263L149.461 5H160.15L159.489 6.07263H154.405L154.371 17H153.161L153.194 6.07263H149.495Z"
        fill="#FF5E1A"
      />
      <path
        d="M156.088 17H154.844L161.099 5H162.528L165 17H163.84L163.184 13.7989H157.753L156.088 17ZM161.469 6.59218L158.274 12.7765H162.982L161.738 6.59218C161.704 6.40782 161.671 6.24022 161.671 6.1229C161.637 6.24022 161.553 6.40782 161.469 6.59218Z"
        fill="#FF5E1A"
      />
    </svg>
  );
}
